// extracted by mini-css-extract-plugin
export default {"root":"ViewAllDeals_root__TaDmG","resultsContainer":"ViewAllDeals_resultsContainer__SaHLz","filterContainer":"ViewAllDeals_filterContainer__FBCRc"};